<div class="py-2" data-testid="tag-picker">
  <span class="mb-1.5 block text-sm font-bold text-gray-700 tracking-tight">Tags</span>
  @if (tags().length > 0) {
    <!--
      Below md: a single row that scrolls horizontally with a visible (thin) scrollbar — never wraps.
      md+: wraps onto multiple rows and scrolls vertically, capped at ~4 rows (max-h-[8.5rem]).
    -->
    <div class="tag-scroll flex flex-nowrap gap-1.5 overflow-x-auto overflow-y-hidden pb-2.5 -mx-0.5 px-0.5
                md:!flex-wrap md:overflow-x-hidden md:overflow-y-auto md:max-h-[8.5rem] md:pb-0 md:justify-center">
      @for (tag of tags(); track tag.id) {
        <button (click)="toggle.emit(tag)"
                [attr.aria-pressed]="isSelected(tag)"
                [style.border-color]="isSelected(tag) ? '#' + tag.color : null"
                [class.text-gray-900]="isSelected(tag)"
                [class.font-semibold]="isSelected(tag)"
                [class.text-gray-500]="!isSelected(tag)"
                [class.font-medium]="!isSelected(tag)"
                [class.border-gray-300]="!isSelected(tag)"
                class="inline-flex shrink-0 items-center gap-1.5 rounded-full border-2 px-2.5 py-1 text-xs whitespace-nowrap max-w-[10rem] transition-all duration-200 active:scale-95 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-theme-primary-500"
                type="button">
          <!-- Colour identity lives on the border + this dot (decorative); the label stays gray-900/500 so
               it always clears AA contrast regardless of the (user-chosen) tag colour. -->
          <svg class="h-2 w-2 shrink-0" [style.color]="isSelected(tag) ? '#' + tag.color : null" viewBox="0 0 8 8">
            <circle cx="4" cy="4" fill="currentColor" r="3"/>
          </svg>
          <span class="truncate">{{ tag.name }}</span>
        </button>
      }
    </div>
  } @else {
    <span class="block py-1 text-xs italic text-gray-500">Keine Tags verfügbar</span>
  }
</div>
